export default __webpack_public_path__ + "static/media/img-0813-czech-republic-half-face.f1e60134.png";